module.exports = __webpack_public_path__ + "img/appgallery.197d3e10.png";